import type { OrderListItemDTO } from '@wf/shared'
import { OrderCard } from '../orders/OrderCard'
import { formatDurationShort } from '../time/format'
import { myActiveOrders, openTaskCount } from './overviewMetrics'

/**
 * Mechaniker-Übersicht: NUR die eigenen Daten — meine zugewiesenen aktiven Aufträge, meine offenen
 * Aufgaben und meine heute gestempelte Anwesenheit. Bewusst KEINE Umsatz-/Chef-Zahlen (RBAC ehrlich).
 */
export function MyWorkToday({
  orders,
  userId,
  todaySeconds,
}: {
  orders: OrderListItemDTO[]
  userId: number
  todaySeconds: number | undefined
}) {
  const mine = myActiveOrders(orders, userId)
  const openTasks = openTaskCount(mine)

  return (
    <section aria-label="Meine Arbeit heute">
      <div className="wf-sectionhead">
        <h3>Meine Arbeit heute</h3>
        <span className="wf-count">{mine.length}</span>
      </div>
      <div className="wf-kpigrid">
        <div className="wf-stat wf-stat--accent">
          <div className="wf-stat__label">Mir zugewiesen</div>
          <div className="wf-stat__value">{mine.length}</div>
          <div className="wf-stat__sub">aktive Aufträge</div>
        </div>
        <div className="wf-stat wf-stat--arbeit">
          <div className="wf-stat__label">Offene Aufgaben</div>
          <div className="wf-stat__value">{openTasks}</div>
          <div className="wf-stat__sub">auf meinen Aufträgen</div>
        </div>
        <div className="wf-stat wf-stat--fertig">
          <div className="wf-stat__label">Heute anwesend</div>
          <div className="wf-stat__value">{todaySeconds != null ? formatDurationShort(todaySeconds) : '—'}</div>
          <div className="wf-stat__sub">gestempelte Zeit</div>
        </div>
      </div>
      {mine.length === 0 ? (
        <p className="wf-ov-empty">Dir ist gerade kein Auftrag zugewiesen. Schnapp dir einen aus der Werkstatt-Liste.</p>
      ) : (
        <div className="wf-cardgrid">
          {mine.map((order) => (
            <OrderCard key={order.id} order={order} />
          ))}
        </div>
      )}
    </section>
  )
}
